// Web Component: PayRowKlarna
// Descrizione: rende cliccabile l'INTERA riga Klarna della card "Paga a rate" inoltrando il
//   click al bottone nativo (button.link[part="osm-cta"]) che il widget Klarna On-Site
//   Messaging espone dentro la propria shadow-root. Il widget dimensiona il bottone al proprio
//   contenuto, quindi senza inoltro la riga aprirebbe il modale solo sull'area del bottone.
// Comportamento:
//   - click sull'area "vuota" della riga -> inoltra il click al bottone nativo;
//   - click già sul bottone nativo -> non inoltra, ci pensa il widget; lo stesso guard evita il
//     loop quando inoltriamo via .click() programmatico.
// Fase di CATTURA: il widget Klarna ha elementi interni che fermano la propagazione (stopPropagation)
//   su alcune sotto-aree, quindi in fase di bubbling il listener non verrebbe raggiunto lì
//   ("il click non registra su alcune parti"). Ascoltando in cattura intercettiamo ogni click nel
//   componente prima dei gestori interni, a prescindere dagli stopPropagation.
// Limite: funziona se la shadow-root del <klarna-placement> è "open" (bottone raggiungibile da
//   JS esterno). Se è "closed" il bottone non è raggiungibile e la riga resta cliccabile solo
//   sull'area nativa (nessuna regressione). Vedi docs/tech-debt.md -> TD-001.
// Contesto: blocco _product-payments, sezione main-product-new (redesign PDP).
class PayRowKlarna extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick, true);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick, true);
  }

  handleClick = (event) => {
    const cta = this.findCta();
    if (!cta) return;

    // base.css forza il <klarna-placement> a riempire tutta la riga, quindi il retargeting dei
    // click compositi mapperebbe OGNI click sull'host — inutilizzabile per distinguere le aree.
    // composedPath() invece attraversa la shadow-root (open) e rivela l'elemento reale cliccato:
    // se è (o contiene) il bottone nativo, ci pensa già il widget e non inoltriamo — questo copre
    // anche il click sintetico di cta.click() qui sotto, evitando il loop.
    if (event.composedPath().includes(cta)) return;

    cta.click();
  };

  // Cerca il bottone nativo Klarna attraversando le shadow-root "open" annidate.
  findCta = (root = this) => {
    const direct = root.querySelector('button.link[part="osm-cta"], button[part="osm-cta"], button.link');
    if (direct) return direct;
    for (const el of root.querySelectorAll('*')) {
      if (el.shadowRoot) {
        const found = this.findCta(el.shadowRoot);
        if (found) return found;
      }
    }
    return null;
  };
}

if (!customElements.get('pay-row-klarna')) {
  customElements.define('pay-row-klarna', PayRowKlarna);
}
